import React, { useContext } from "react";
// import { Link } from "react-router-dom";
import { Avatar, Box, Grid } from "@mui/material";
import videoHere from "../../img/video2.webp";
import pichere from "../../img/programming.gif";
import picgithub from "../../img/github.png";
import piclinkedin from "../../img/linkedin_logo.png";
import pictwitter from "../../img/twitter_logo.png";
import picdevCommunity from "../../img/dev-community-logo.png";
import ChatbotComponent from "../Pages/ChatbotComponent";

import "./home.css";
import "../Css/commoncolor.css";
import { motion } from "framer-motion";
import { ThemeContext } from "../../context";
import SmokeCursor from "../Pages/SmokeCursor";

const Home = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  const animations = {
    initial: { opacity: 0, x: -100 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -100 },
  };

  const animationa = {
    initial: { opacity: 0, x: 100 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -100 },
  };

  return (
    <Grid
      container
      height={{
        xs: "100vh",
        lg: "100vh",
      }}
      overflow="hidden"
    >
      <SmokeCursor />
      {/* <video src={videoHere} autoPlay loop muted className="background-home" /> */}
      <img
        src={videoHere}
        alt="animated background"
        className="background-home"
        style={{ width: "100%", height: "100vh", objectFit: "cover" }}
      />

      <Box className="text-home" flexDirection={{ xs: "column", md: "row" }}>
        <motion.div
          variants={animations}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 1 }}
        >
          <Avatar
            sx={{
              height: { xs: "200px", lg: "300px" },
              width: { xs: "200px", lg: "300px" },
            }}
            src={pichere}
            className="home-avatar"
          />
        </motion.div>
        <motion.div
          variants={animationa}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 1 }}
        >
          <Box
            display="flex"
            flexDirection="column"
            marginLeft="18px"
            marginTop={{ xs: "16px", md: "0" }}
            textAlign={{ xs: "center", md: "left" }}
            sx={{
              color: darkMode ? "#fff" : "#a5a5a5",
            }}
          >
            <span className="i-intro">Hey! I'm</span>
            <span className="i-name">Deepangshi Saha</span>
            <span className="i-namee">Software Engineer</span>

            <div className="i-title">
              <div className="i-title-wrapper">
                <div className="i-title-item">IT Graduate👩🏻‍🎓</div>
                <div className="i-title-item">Software Developer</div>
              </div>
            </div>

            {/* <Link to="/Contact">
                <Button
                  className="btn-home"
                  style={{
                    paddingLeft: "24px",
                    paddingRight: "24px",
                    borderRadius: "5px",
                    border: darkMode
                      ? "2px solid #ffffff"
                      : "2px solid #a5a5a5",
                    backgroundColor: "transparent",
                    color: darkMode ? "#ffffff" : "#a5a5a5",
                    cursor: "pointer",
                    textTransform: "none",
                  }}
                >
                  Contact
                </Button>
              </Link> */}
            <Box
              sx={{
                display: "flex",
                margin: { xs: "auto", lg: "0" },
              }}
            >
              <Box
                sx={{
                  width: { xs: "35px", md: "50px" },
                  height: { xs: "35px", md: "50px" },
                  paddingTop: { xs: "12px", lg: "20px" },
                }}
              >
                <a
                  href="https://github.com/Deepangshi"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={picgithub}
                    alt=""
                    title="Feel free to collaborate with me on GitHub"
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </a>
              </Box>
              <Box
                sx={{
                  width: { xs: "30px", md: "50px" },
                  height: { xs: "30px", md: "50px" },
                  paddingTop: { xs: "12px", lg: "20px" },
                  // margin: { xs: "auto", lg: "0" },

                  paddingLeft: "8px",
                }}
              >
                <a
                  href="https://www.linkedin.com/in/deepangshi-saha/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={piclinkedin}
                    alt=""
                    title="Let's Connect on LinkedIn"
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </a>
              </Box>
              <Box
                sx={{
                  width: { xs: "35px", md: "50px" },
                  height: { xs: "35px", md: "50px" },
                  paddingTop: { xs: "12px", lg: "20px" },
                  paddingLeft: "8px",
                }}
              >
                <a
                  href="https://x.com/deepangshi"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={pictwitter}
                    alt=""
                    title="Follow on X"
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </a>
              </Box>
              <Box
                sx={{
                  width: { xs: "35px", md: "50px" },
                  height: { xs: "35px", md: "50px" },
                  paddingTop: { xs: "12px", lg: "20px" },
                  paddingLeft: "8px",
                }}
              >
                <a
                  href="https://dev.to/thedsdev"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={picdevCommunity}
                    alt=""
                    title="Lets' Learn Together in Dev Community"
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </a>
              </Box>
            </Box>
          </Box>
        </motion.div>
      </Box>
      <ChatbotComponent />
    </Grid>
  );
};

export default Home;
